import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  maxWidthSelect: {
    maxWidth: '200px',
    minWidth: '150px',
  },
  minWidthTextField: {
    minWidth: '100px',
  },
  svgRotated: {
    transform: 'rotate(-90deg)',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    color: '#707070',
  },
  svgEnabledContainer: {
    '& :hover': {
      color: '#8800ff',
    },
  },
  svgDisabledContainer: {
    '& :hover': {
      color: '#b2b2b2',
    },
  },
  svgGray: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    color: '#707070',
  },
  svgDisabled: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    color: '#edecf2',
  },
  datagridRoot: {
    '& .MuiDataGrid-iconSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#edecf252',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      color: '#707070',
    },
  },
}));

export default useStyles;
